import { RouteConfig } from "vue-router";

export const ShopReportRoutes: Array<RouteConfig> = [ {
                path: '/shops/:instance_id',
                // name: 'shop-reports',
                name: 'shop-dashboard',
                meta: {
                    parent: 'shop'
                },
                component: () => import(/* webpackChunkName: "shop-report" */ './views/ShopReport.vue'),
        },
]